import { css } from '@emotion/react';
import vars from '../../../styles/custom-properties.js';

var getAlignItem = function getAlignItem(alignment) {
  switch (alignment) {
    case 'flexStart':
      return 'flex-start';
    case 'flexEnd':
      return 'flex-end';
    default:
      return alignment;
  }
};
var getMargin = function getMargin(scale) {
  switch (scale) {
    case 'xs':
      return vars.spacingXs;
    case 's':
      return vars.spacingS;
    case 'm':
      return vars.spacingM;
    case 'l':
      return vars.spacingL;
    case 'xl':
      return vars.spacingXl;
    default:
      return 0;
  }
};
var getInlineStyles = function getInlineStyles(props) {
  return css("display:flex;align-items:", props.alignItems && getAlignItem(props.alignItems), ";justify-content:", props.justifyContent, ";flex-direction:", props.flexDirection, ";flex-wrap:", props.flexWrap, ";>*+*{margin:0 0 0 ", getMargin(props === null || props === void 0 ? void 0 : props.scale), " ", props.noImportant ? '' : '!important', ";}" + ("production" === "production" ? "" : ";label:getInlineStyles;"), "production" === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUE0QnVDIiwiZmlsZSI6InN0eWxlcy50cyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNzcyB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcbmltcG9ydCB7IGN1c3RvbVByb3BlcnRpZXMgYXMgdmFycyB9IGZyb20gXCIuLi8uLi8uLi9zdHlsZXNcIjtcbmNvbnN0IGdldEFsaWduSXRlbSA9IChhbGlnbm1lbnQpID0+IHtcbiAgICBzd2l0Y2ggKGFsaWdubWVudCkge1xuICAgICAgICBjYXNlICdmbGV4U3RhcnQnOlxuICAgICAgICAgICAgcmV0dXJuICdmbGV4LXN0YXJ0JztcbiAgICAgICAgY2FzZSAnZmxleEVuZCc6XG4gICAgICAgICAgICByZXR1cm4gJ2ZsZXgtZW5kJztcbiAgICAgICAgZGVmYXVsdDpcbiAgICAgICAgICAgIHJldHVybiBhbGlnbm1lbnQ7XG4gICAgfVxufTtcbmNvbnN0IGdldE1hcmdpbiA9IChzY2FsZSkgPT4ge1xuICAgIHN3aXRjaCAoc2NhbGUpIHtcbiAgICAgICAgY2FzZSAneHMnOlxuICAgICAgICAgICAgcmV0dXJuIHZhcnMuc3BhY2luZ1hzO1xuICAgICAgICBjYXNlICdzJzpcbiAgICAgICAgICAgIHJldHVybiB2YXJzLnNwYWNpbmdTO1xuICAgICAgICBjYXNlICdtJzpcbiAgICAgICAgICAgIHJldHVybiB2YXJzLnNwYWNpbmdNO1xuICAgICAgICBjYXNlICdsJzpcbiAgICAgICAgICAgIHJldHVybiB2YXJzLnNwYWNpbmdMO1xuICAgICAgICBjYXNlICd4bCc6XG4gICAgICAgICAgICByZXR1cm4gdmFycy5zcGFjaW5nWGw7XG4gICAgICAgIGRlZmF1bHQ6XG4gICAgICAgICAgICByZXR1cm4gMDtcbiAgICB9XG59O1xuY29uc3QgZ2V0SW5saW5lU3R5bGVzID0gKHByb3BzKSA9PiBjc3MgYFxuICBkaXNwbGF5OiBmbGV4O1xuICBhbGlnbi1pdGVtczogJHtwcm9wcy5hbGlnbkl0ZW1zICYmIGdldEFsaWduSXRlbShwcm9wcy5hbGlnbkl0ZW1zKX07XG4gIGp1c3RpZnktY29udGVudDogJHtwcm9wcy5qdXN0aWZ5Q29udGVudH07XG4gIGZsZXgtZGlyZWN0aW9uOiAke3Byb3BzLmZsZXhEaXJlY3Rpb259O1xuICBmbGV4LXdyYXA6ICR7cHJvcHMuZmxleFdyYXB9O1xuXG4gID4gKiArICoge1xuICAgIG1hcmdpbjogMCAwIDAgJHtnZXRNYXJnaW4ocHJvcHM/LnNjYWxlKX0gJHtwcm9wcy5ub0ltcG9ydGFudCA/ICcnIDogJyFpbXBvcnRhbnQnfTtcbiAgfVxuYDtcbmV4cG9ydCB7IGdldElubGluZVN0eWxlcyB9O1xuLy8jIHNvdXJjZU1hcHBpbmdVUkw9c3R5bGVzLmpzLm1hcCJdfQ== */");
};

export { getInlineStyles };
//# sourceMappingURL=styles.js.map
